import { TAGULAR_EVENT_TYPES } from "@/types/tagular";
import { tagular } from "@redventures/cohesion-utils-react";

/**
 * @module Core Web Vitals
 * @description Core Web Vitals Reporting
 * @see https://web.dev/articles/defining-core-web-vitals-thresholds#refresher_core_web_vitals_metrics_and_thresholds
 */
const thresholds = {
  CLS: [0.1, 0.25],
  FCP: [1800, 3000],
  INP: [200, 500],
  LCP: [2500, 4000],
  TTFB: [100, 600],
  FID: [100, 300],
} as const;

/**
 * @function getRating
 * @description Get Core Web Vitals rating for each metric.
 * @see https://github.com/GoogleChromeLabs/web-vitals-report/blob/71b0879334798c732f460945ded5267cab5a36bf/src/js/analytics.js#L57-L65
 *
 * @param  {Number}  value
 * @param  {Array}   thresholds
 * @return {String}
 */
const getRating = (value: number, threshold: readonly [number, number]) => {
  if (value > threshold[1]) return "POOR";
  if (value > threshold[0]) return "NI"; // NI == Needs Improvement
  return "GOOD";
};

type MetricName = keyof typeof thresholds;

const sendToAnalytics = (metric: { name: MetricName; value: number }) => {
  const { name, value } = metric;

  try {
    tagular("beam", {
      "@type": TAGULAR_EVENT_TYPES.CORE_WEB_VITALS,
      metricName: String(name),
      rating: getRating(value, thresholds[name]),
      value: Number(value),
    });
  } catch (error) {
    console.error(error);
  }
};

export default sendToAnalytics;
